export default __webpack_public_path__ + "images/21eee374f958b0938cad8ae3e38f80a9.png";